import React from 'react';
import { MainLayout } from '@components';
import ECGsComponents from './ECGs';

export default function ECGsPage(props) {
  return <MainLayout footer="main" children={<ECGsComponents {...props} />} />;
}
